<template>
    <div class="parking-canvas">
        <div class="parking-canvas__panzoom">
            <PanZoom :options="options" @registerSvgPanZoom="registerSvgPanZoom">
                <svg :viewBox="[`0 0 ${render.width} ${render.height}`]"
                     preserveAspectRatio="xMidYMid meet">

                    <path v-for="element in elements"
                          :key="element.id"
                          :d="element.path"
                          :id="`path-${element.id}`"
                          :fill="element.fill ? element.fill : '#95BA20'"
                          class="parking-canvas__path"
                          @mouseenter="mouseenter(element)"
                          @mousemove="mousemove(element)"
                          @mouseleave="mouseleave(element)"
                          ref="path"/>

                    <image x="0" y="0" width="100%" height="100%"
                           :xlink:href="render.src" class="parking-canvas__image"/>
                </svg>
            </PanZoom>

            <Panel :data="activeElement" @close="activeElement = null" @submit="clickPath"/>
        </div>

        <Tooltip />
    </div>
</template>

<script>
import Bus from '../../Bus';
import Hammer from 'hammerjs';
import Panel from '../Panel/Panel.vue';
import PanZoom from '../PanZoom/PanZoom.vue';
import Tooltip from '../Tooltip/Tooltip.vue';

export default {
    props: ['floor', 'elements'],

    components: {
        PanZoom,
        Tooltip,
        Panel
    },

    data: () => {
        return {
            svgpanzoom   : null,
            activeElement: null,
            options      : {
                setMinZoom: true,
                minZoom   : 0.85
            }
        };
    },

    computed: {
        render() {
            return (this.floor && this.floor.render) || null;
        }
    },

    watch: {
        elements() {
            this.$nextTick(() => {
                this.setPathEventsHandler();
            });
        }
    },

    methods: {
        registerSvgPanZoom(svgpanzoom) {
            this.svgpanzoom = svgpanzoom;

            this.setPathEventsHandler();
        },

        setPathEventsHandler() {
            Array.from(this.$refs.path).forEach((path) => {
                if (path.hasAttribute('init')) {
                    return;
                }

                path.setAttribute('init', 'true');

                new Hammer(path).on('tap', () => {
                    const activeElement = this.elements.find((element) => {
                        return `path-${element.id}` === path.id;
                    });

                    if (this.isMobile()) {
                        this.activeElement = this.activeElement === activeElement ? null : activeElement;
                    } else {
                        this.clickPath(activeElement);
                    }
                });
            });
        },

        clickPath(element) {
            this.activeElement = null;
            this.$emit('clickElement', element);
        },

        mouseenter(element) {
            if (this.isMobile()) {
                return;
            }

            Bus.$emit('tooltip:data', {
                type   : 'parking',
                tooltip: element,
                modify : ''
            });
            Bus.$emit('tooltip:show', true);
        },

        mousemove() {
            if (this.isMobile()) {
                return;
            }

            Bus.$emit('tooltip:coords', {
                x: event.clientX,
                y: event.clientY
            });
        },

        mouseleave() {
            Bus.$emit('tooltip:show', false);
            Bus.$emit('tooltip:data', {});
        },

        isMobile() {
            const desktopBreakpoint = 1280;

            return window.innerWidth < desktopBreakpoint;
        }
    }
};
</script>

